module.exports = __webpack_public_path__ + "dataanalysestatic/img/moniqi.5074f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moniqi.png
// module id = hlHw
// module chunks = 37